<mat-dialog-content>
  @if (isLoading()) {
    <div class="loading-container">
      <glxy-loading-spinner></glxy-loading-spinner>
    </div>
  } @else {
    <mat-stepper #stepper [linear]="true" [labelPosition]="'bottom'" (selectionChange)="stepChanged($event)">
      <mat-step [stepControl]="form" [completed]="isStepZeroComplete()">
        <ng-template matStepLabel>{{ 'EDIT_KNOWLEDGE.FILE_UPLOAD_CONFIG.UPLOAD_FILES' | translate }}</ng-template>
        <ng-template matStepContent>
          <div class="step-content">
            @if (hasExistingFileOnly()) {
              <div class="existing-file-section">
                <h4>{{ 'EDIT_KNOWLEDGE.FILE_UPLOAD_CONFIG.CURRENT_FILE' | translate }}</h4>
                <div class="existing-file-item">
                  <mat-icon>{{ getFileIcon() }}</mat-icon>
                  <span class="file-name">{{ getCurrentFileName() }}</span>
                  <span class="file-type">{{ getCurrentFileType() }}</span>
                  <glxy-button-group class="inline-button-group">
                    <button
                      mat-stroked-button
                      (click)="viewCurrentFile()"
                      [matTooltip]="'EDIT_KNOWLEDGE.FILE_UPLOAD_CONFIG.VIEW_FILE' | translate"
                    >
                      <mat-icon>visibility</mat-icon>
                    </button>
                    <button
                      mat-stroked-button
                      (click)="downloadCurrentFile()"
                      [matTooltip]="'EDIT_KNOWLEDGE.FILE_UPLOAD_CONFIG.DOWNLOAD_FILE' | translate"
                    >
                      <mat-icon>download</mat-icon>
                    </button>
                  </glxy-button-group>
                </div>
                <p class="replace-file-text">
                  {{ 'EDIT_KNOWLEDGE.FILE_UPLOAD_CONFIG.UPLOAD_NEW_TO_REPLACE' | translate }}
                </p>
              </div>
            }

            <div class="upload-section">
              <h3>{{ 'EDIT_KNOWLEDGE.FILE_UPLOAD_CONFIG.SELECT_FILE' | translate }}</h3>
              <p>{{ 'EDIT_KNOWLEDGE.FILE_UPLOAD_CONFIG.DESCRIPTION' | translate }}</p>

              <glxy-uploader
                [uploadUrl]="uploadUrl"
                [maxFiles]="maxFiles"
                [maxFileSize]="maxFileSize"
                [accept]="acceptedFileTypes"
                [autoUpload]="true"
                [layout]="'default'"
                [hintText]="'EDIT_KNOWLEDGE.FILE_UPLOAD_CONFIG.HINT_TEXT' | translate"
                [descriptionText]="[
                  'EDIT_KNOWLEDGE.FILE_UPLOAD_CONFIG.DRAG_DROP_SINGULAR' | translate,
                  'EDIT_KNOWLEDGE.FILE_UPLOAD_CONFIG.DRAG_DROP_SINGULAR' | translate,
                ]"
                [buttonText]="[
                  'EDIT_KNOWLEDGE.FILE_UPLOAD_CONFIG.CHOOSE_FILE_SINGULAR' | translate,
                  'EDIT_KNOWLEDGE.FILE_UPLOAD_CONFIG.CHOOSE_FILE_SINGULAR' | translate,
                ]"
                (fileUploaded)="onFileUploaded($event)"
                (fileUploadErrored)="onFileUploadError($event)"
                (filesChanged)="onFilesChanged($event)"
              ></glxy-uploader>
            </div>

            @if (uploadedFile()) {
              <div class="uploaded-file-section">
                <h4>{{ 'EDIT_KNOWLEDGE.FILE_UPLOAD_CONFIG.UPLOADED_FILE' | translate }}</h4>
                <div
                  class="file-item"
                  [class.success]="uploadedFile().status === 2"
                  [class.error]="uploadedFile().status === 3"
                  [class.uploading]="uploadedFile().status === 1"
                >
                  <mat-icon>
                    @switch (uploadedFile().status) {
                      @case (2) {
                        check_circle
                      }
                      @case (3) {
                        error
                      }
                      @default {
                        cloud_upload
                      }
                    }
                  </mat-icon>
                  <span class="file-name">{{ uploadedFile().name }}</span>
                  @if (uploadedFile().status === 1) {
                    <span class="uploading-text">{{ 'COMMON.UPLOADING' | translate }}</span>
                  }
                </div>
              </div>
            }

            <div class="form-section">
              <form [formGroup]="form">
                <glxy-form-field [required]="true">
                  <glxy-label>{{ 'EDIT_KNOWLEDGE.NAME' | translate }}</glxy-label>
                  <input
                    matInput
                    formControlName="name"
                    [placeholder]="'EDIT_KNOWLEDGE.FILE_UPLOAD_CONFIG.NAME_PLACEHOLDER' | translate"
                  />
                  @if (form.get('name')?.errors && form.get('name')?.dirty) {
                    <glxy-error>
                      {{ 'EDIT_KNOWLEDGE.FIELD_REQUIRED' | translate }}
                    </glxy-error>
                  }
                </glxy-form-field>
              </form>
            </div>

            @if (otherAIDisclaimer()) {
              <div class="disclaimer-section">
                <div [innerHTML]="otherAIDisclaimer()"></div>
              </div>
            }
          </div>
        </ng-template>
      </mat-step>

      @if (!excludeAddToAIStep) {
        <mat-step>
          <ng-template matStepLabel>{{ 'EDIT_KNOWLEDGE.ADD_TO_AI' | translate }}</ng-template>
          <ng-template matStepContent>
            <ai-knowledge-application-selector
              #applicationSelector
              [knowledgeSourceId]="knowledgeSource?.id"
              (createWidgetClicked)="createWebChatWidget()"
            ></ai-knowledge-application-selector>
          </ng-template>
        </mat-step>
      }
    </mat-stepper>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (shouldShowBack()) {
    <button mat-stroked-button (click)="back()">
      {{ 'COMMON.BACK' | translate }}
    </button>
  }
  <button mat-flat-button color="primary" (click)="submit()">
    {{ submitActionText() | translate }}
  </button>
  <button mat-stroked-button (click)="close()">
    {{ 'COMMON.CANCEL' | translate }}
  </button>
</mat-dialog-actions>
